export enum GolfCollisionEntityType {
  Any = 1, // Wildcard
  Missile = 2,
  Shield = 3,
  ShipPart = 4,
  Fighter = 5,
}
export interface IFixDef {
  isSensor?: boolean
  friction?: number
  restitution?: number
  density?: number
  userData?: GolfCollisionEntityType
}
export interface IBodyDef {
  linearDamping?: number
  angularDamping?: number
}

export interface IGolfPhysicsDef {
  fix: IFixDef
  body: IBodyDef
}

export const missilePhysicsDef: IGolfPhysicsDef = {
  fix: {
    // isSensor: true,
    userData: GolfCollisionEntityType.Missile,
  },
  body: {},
}

export const shieldPhysicsDef: IGolfPhysicsDef = {
  fix: {
    // isSensor: true,
    userData: GolfCollisionEntityType.Shield,
  },
  body: {},
}

export const shipPartPhysicsDef: IGolfPhysicsDef = {
  fix: {
    // isSensor: true,
    userData: GolfCollisionEntityType.ShipPart,
  },
  body: {},
}

export const fighterPhysicsDef: IGolfPhysicsDef = {
  fix: {
    // isSensor: true,
    userData: GolfCollisionEntityType.Fighter,
  },
  body: {},
}

export const borderPhysicsDef: IGolfPhysicsDef = {
  fix: {
    // isSensor: true,
    userData: GolfCollisionEntityType.Fighter,
    friction: 0.1,
    restitution: 0.99,
    density: 1,
  },
  body: {
    linearDamping: 1.5,
    angularDamping: 1,
  },
}
export const puckPhysicsDef: IGolfPhysicsDef = {
  fix: {
    // isSensor: true,
    userData: GolfCollisionEntityType.Fighter,
    friction: 0.1,
    restitution: 0.99,
    density: 1,
  },
  body: {
    linearDamping: 1.5,
    angularDamping: 1,
  },
}

// export const monsterFixDef: IFixDef = {
//   friction: 0.1,
//   restitution: 0.99,
//   density: 1,
//   userData: 'monster',
// }
// export const monsterBodyDef: IBodyDef = {
//   linearDamping: 1.5,
//   angularDamping: 1,
// }

// export const boundaryBodyDef: IBodyDef = {
//   linearDamping: 1.5,
//   angularDamping: 1,
// }
// export const boundaryFixDef: IFixDef = {
//   friction: 0.1,
//   restitution: 0.9,
//   userData: 'boundary',
// }

// export const pillarBodyDef: IBodyDef = {
//   linearDamping: 1.5,
//   angularDamping: 1,
// }
// export const pillarFixDef: IFixDef = {
//   friction: 0.1,
//   restitution: 0.9,
//   userData: 'pillar',
// }

// export const stairsBodyDef: IBodyDef = {
//   linearDamping: 1.5,
//   angularDamping: 1,
// }
// export const stairsFixDef: IFixDef = {
//   isSensor: true,
//   friction: 0.1,
//   restitution: 0.9,
//   userData: 'stairs',
// }

// export const sensorFixDev: IFixDef = {
//   isSensor: true,
//   userData: 'sensor',
// }
// export const spawnerFixDev: IFixDef = {
//   isSensor: false,
//   userData: 'spawner',
// }

// export const pickupFixDef: IFixDef = {
//   friction: 0.1,
//   restitution: 0.99,
//   density: 1,
//   userData: 'pickup',
// }
// export const pickupBodyDef: IBodyDef = {
//   linearDamping: 1.5,
//   angularDamping: 1,
// }

// export const spellFixDev: IFixDef = {
//   friction: 0.1,
//   restitution: 0.99,
//   density: 1,
//   userData: 'spell',
// }
// export const spellBodyDef: IBodyDef = {
//   linearDamping: 1.5,
//   angularDamping: 1,
// }

//http://piqnt.com.s3-website-us-east-1.amazonaws.com/planck.js/example/8-Ball.js?v=4
// var railFixDef = {
//   friction: 0.1,
//   restitution: 0.9,
//   userData: 'rail'
// };
// var pocketFixDef = {
//   userData: 'pocket'
// };
// var ballFixDef = {
//   friction: 0.1,
//   restitution: 0.99,
//   density: 1,
//   userData: 'ball'
// };
// var ballBodyDef = {
//   linearDamping: 1.5,
//   angularDamping: 1
// };
